var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wapp-icon"},[_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._m(0),_c('div',{staticClass:"logo"})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titlewapp-cont"},[_c('p',[_vm._v("Platiquemos de tu proyecto")])])
}]

export { render, staticRenderFns }